/**
 * A class to provide the API for rendering a visualization.
* @property {function} redraw - A function that, when invoked, will force the visualization to redraw
*/
export default class RenderApi {
    /**
     * Create a new RenderApi
     * @param {object} options - See below
     * @param {function} options.redraw - A function that, when invoked, will force the visualization to redraw
     */
    constructor(options) {
        if(!options || typeof options !== 'object') {
            throw new TypeError(`options must be an object. Provided value: ${JSON.stringify(options)}`);
        }

        const { redraw } = options;

        if(typeof redraw !== 'function') {
            throw new TypeError(`options.redraw must be an function. Provided value: ${JSON.stringify(redraw)}`);
        }

        Object.assign(this, {
            redraw
        });

        Object.freeze(this);
    }
}
